import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "reservascuchillaalta-90e5d.firebaseapp.com",
  projectId: "reservascuchillaalta-90e5d",
  storageBucket: "reservascuchillaalta-90e5d.appspot.com",
  messagingSenderId: "553095616921",
  appId: "1:553095616921:web:397191525ecbd530e69b08",
};

firebase.initializeApp(firebaseConfig);

firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .then(() => {
    console.log("Persistencia establecida correctamente.");
  })
  .catch((error) => {
    console.error("Error al establecer la persistencia:", error);
  });

firebase.auth().languageCode = 'es';

const auth = firebase.auth();
const firestore = firebase.firestore();

window.firebase = firebase;

export { firebase, auth, firestore };
